<style lang="scss" scoped="scoped">
	// ::-webkit-scrollbar {
	// 	width: 0 !important
	// }
	::-webkit-scrollbar {
		display: none;
	}

	.vue-grid-item {
		background: #202027;
		// overflow: auto;
		box-sizing: border-box;
		position: relative;
	}

	.vue-grid-item.vue-grid-placeholder {
		background: #419FFF !important;
	}

	.el-dropdown-link {
		cursor: pointer;
		color: #419FFF;
	}

	.bg {
		background: rgb(18, 18, 18);
	}


	// .vue-grid-layout::-webkit-scrollbar {
	// 	width: 0 !important
	// }

	.module-grid {
		background: #202027;
	}
</style>
<style lang="scss">
	.el-popper {
		margin-right: 10px;
	}

	.monitorProductionJy .el-input__inner {
		color: #419FFF;
		border: none;
		background-color: transparent;
		text-align: right;
		width: 260px;
	}

	.monitorProductionJy .el-cascader .el-input .el-icon-arrow-down {
		color: #419FFF;

	}

	.monitorProductionJy .el-input__inner::-webkit-input-placeholder {
		color: #419FFF;
	}
</style>

<template>
	<div style="display: inline;">
		<div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
			<div ref="header" style="padding: 34px 34px  0px  34px;">
				<div class="module-grid"
					style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
					<div style="width: 340px;cursor: pointer;">
						<img @click="utils.event_hub.$emit('TOGGLE_TABBAR',!store.state.is_monitor_full)"
							style="height: 38px;width: auto;" :src="logoSrc" />
					</div>
					<div style="font-weight: 700;font-size: 30px;color: white;">
						{{store.state.customer.shortName}}-{{$t('shengchanjindujiankong')}}-{{$t('daichan')}}</div>
					<div class="monitorProductionJy"
						style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
						<p style="font-size: 14px;color:white;">{{store.state.currentTime}}</p>
						<div style="display: flex;align-items: center;">
							<yi_data_select :type="'organization'" :ids.sync="orgId">
							</yi_data_select>
							<el-link @click="showBoardEdit()" style="color:#419FFF ;margin-left: 8px;font-size: 12px;"
								icon="yicon yicon-pencil">
								{{$t('bianjikanban')}}
							</el-link>
						</div>
					</div>
				</div>
			</div>
			<div style="padding: 0px 14px 34px  14px;">
				<grid-layout v-if="gridContainerHeight!=0" :layout.sync="layout" :col-num="24" :maxRows="24"
					:row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false"
					:vertical-compact="true" :margin="[20, 20]" :use-css-transforms="true"
					:style="{'height': gridContainerHeight+'px'}" style="overflow: auto;">

					<grid-item :refs="'grid_'+item.i" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w"
						:h="item.h" :i="item.i" :key="item.i">
						<component v-bind:is="item.i" :orgId="orgId" :which="'waiting'">
						</component>
					</grid-item>
				</grid-layout>
			</div>
		</div>
		<el-dialog :show-close="true" :title="$t('kanpanshezhi')" :visible.sync="isShowBoardEdit"
			:close-on-click-modal="false" width="874px" append-to-body>
			<setting ref="setting"></setting>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowBoardEdit= false">{{$t('quxiao')}}</el-button>
				<el-button size="mini" @click="$refs.setting.save();isShowBoardEdit= false" type="primary">
					{{$t('baocun')}}
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import VueGridLayout from 'vue-grid-layout';
	import row from '@@/pages/web/monitor/production_all/jy/row';
	import setting from '@@/pages/web/monitor/production_all/jy/setting';
	export default {
		name: 'web_monitor_production_waiting_jy_index',
		components: {
			GridLayout: VueGridLayout.GridLayout,
			GridItem: VueGridLayout.GridItem,
			row: row,
			setting:setting,
		},

		data() {
			return {
				isShowBoardEdit: false,
				orgId: this.store.state.organizations[0].id,
				gridContainerHeight: 0,
				gridRowHeihgt: 0,
				show: "row", //row,card
				layout: [{
					"x": 0,
					"y": 0,
					"w": 24,
					"h": 24, //应该是6
					"i": ""
				}],
			};
		},
		computed: {
			logoSrc() {
				return this.store.state.logo_url ? this.store.state.logo_url : require('@@/assets/img/web/workshop/logo.png');
			},
		},

		created() {
			this.utils.event_hub.$emit('TOGGLE_TABBAR', true)
		},
		activated() {
			this.resize()
		},
		mounted() {
			this.show = "row"
			this.layout[0].i = this.show
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();

			});
		},
		destroyed() {},
		methods: {
			showBoardEdit() {
				this.isShowBoardEdit = true
				this.$nextTick(() => {
					this.$refs.setting.resetData()
				})
			},
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {
					this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header
						.offsetHeight - 34
					this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24

				}, 500)

			},
		}
	};
</script>
